// =============================================================================
// Ella Custom JS - Customize The Style For Layout
// =============================================================================
// IMPORTANT DISCLAIMER: Please use only JS to style the layout.
// =============================================================================
// Riga presente prima del 22/10/2026 (non era JavaScript valido e bloccava il file, lasciata come nota):
// <meta name="facebook-domain-verification" content="261ld3z41kh7y75eda97vml1ymns3x" />

/* -----------------------------------------------------------------------------
   Arte Riflessa - Made in Italy e fabbricazione artigianale su ordinazione
   HubNormal, 22/10/2026. Stili in assets/custom.css (sezione «ar-mii»).
   - Etichetta «Made in Italy» in alto a sinistra sulle foto prodotto: galleria della
     scheda (.productView-img-container) e card delle collezioni (.card-media).
     Al 22/10/2026 tutti i 35 prodotti pubblicati sono Arte Riflessa: se tornano prodotti
     di altri marchi, escluderli (attributo data-ar-mii-skip su un contenitore).
   - In scheda, sopra la stima di consegna: «Fabriqué à la main en Italie, sur commande».
   - Nel carrello laterale e nella pagina carrello, sopra il pulsante di pagamento:
     riquadro sulla fabbricazione artigianale dopo l'ordine.
   Se cambiano i tempi (2 semaines / 3 à 5 jours ouvrés) aggiornare i testi qui sotto.
----------------------------------------------------------------------------- */
(function () {
  if (window.__arMii) return;
  window.__arMii = true;

  var IT = (document.documentElement.lang || '').toLowerCase().indexOf('it') === 0;
  var T = IT ? {
    craft: '<strong>Realizzato a mano in Italia</strong>, su ordinazione, in circa 2 settimane',
    cartTitle: 'Realizzato a mano in Italia, su ordinazione',
    cartText: 'I nostri artigiani realizzano il tuo pezzo appena confermi l’ordine, in circa 2 settimane, poi la consegna richiede 3-5 giorni lavorativi.'
  } : {
    craft: '<strong>Fabriqué à la main en Italie</strong>, sur commande, en 2 semaines environ',
    cartTitle: 'Fabriqué à la main en Italie, sur commande',
    cartText: 'Nos artisans réalisent votre pièce dès la confirmation de la commande, en 2 semaines environ, puis elle vous est livrée gratuitement en 3 à 5 jours ouvrés.'
  };

  var BADGE = '<span class="ar-mii__flag" aria-hidden="true"></span>Made in Italy';
  var ICON = '<svg class="ar-eta__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M18 11V6a2 2 0 0 0-4 0"/><path d="M14 10V4a2 2 0 0 0-4 0v2"/><path d="M10 10.5V6a2 2 0 0 0-4 0v8"/>' +
    '<path d="M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-6-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15"/></svg>';

  function badges() {
    document.querySelectorAll('.productView-img-container, .card-media').forEach(function (el) {
      if (el.querySelector(':scope > .ar-mii') || el.closest('[data-ar-mii-skip]')) return;
      var b = document.createElement('span');
      b.className = 'ar-mii';
      b.innerHTML = BADGE;
      el.appendChild(b);
    });
  }

  function craftRow() {
    document.querySelectorAll('[data-ar-eta]').forEach(function (eta) {
      var prev = eta.previousElementSibling;
      if (prev && prev.hasAttribute('data-ar-craft')) return;
      var row = document.createElement('div');
      row.className = 'ar-eta ar-eta--craft';
      row.setAttribute('data-ar-craft', '');
      row.innerHTML = ICON + '<p class="ar-eta__text">' + T.craft + '</p>';
      eta.parentNode.insertBefore(row, eta);
    });
  }

  function cartNotes() {
    var spots = [];
    document.querySelectorAll('#cart-sidebar-checkout').forEach(function (btn) {
      var g = btn.closest('.previewCartGroup');
      if (g) spots.push(g);
    });
    document.querySelectorAll('.cart-actions .action-group').forEach(function (g) { spots.push(g); });
    spots.forEach(function (g) {
      var prev = g.previousElementSibling;
      if (prev && prev.hasAttribute('data-ar-mii-cart')) return;
      var box = document.createElement('div');
      box.className = 'ar-mii-cart';
      box.setAttribute('data-ar-mii-cart', '');
      box.innerHTML = '<p class="ar-mii-cart__title">' + T.cartTitle + '</p><p class="ar-mii-cart__text">' + T.cartText + '</p>';
      g.parentNode.insertBefore(box, g);
    });
  }

  function run() { badges(); craftRow(); cartNotes(); }

  function start() {
    run();
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () { queued = false; run(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
